<template>
  <div
    class="transition-colors duration-300 text-l-medium text-black-white w-92 min-w-0 h-8 flex flex-1 items-center justify-center m-auto rounded-7xl"
  >
    <Icon class="size-6" :icon="icon"></Icon>
    {{ name }}
  </div>
</template>

<script lang="ts" setup>
  import { Icon } from '@rapoo/element'

  const props = withDefaults(
    defineProps<{
      name?: string
      icon?: string
    }>(),
    {
      name: '',
      icon: '',
    },
  )
</script>

<style lang="scss" scoped></style>
